
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb7cf"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb7cf"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gxIVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5169d9c2c7b13f49$export$2e2bcd8739ae039);
function $5169d9c2c7b13f49$var$t(t, e, i) {
    return Math.max(t, Math.min(e, i));
}
class $5169d9c2c7b13f49$var$Animate {
    advance(e) {
        if (!this.isRunning) return;
        let i = !1;
        if (this.lerp) this.value = (s = this.value, o = this.to, n = 60 * this.lerp, l = e, function(t, e, i) {
            return (1 - i) * t + i * e;
        }(s, o, 1 - Math.exp(-n * l))), Math.round(this.value) === this.to && (this.value = this.to, i = !0);
        else {
            this.currentTime += e;
            const s = $5169d9c2c7b13f49$var$t(0, this.currentTime / this.duration, 1);
            i = s >= 1;
            const o = i ? 1 : this.easing(s);
            this.value = this.from + (this.to - this.from) * o;
        }
        var s, o, n, l;
        this.onUpdate?.(this.value, i), i && this.stop();
    }
    stop() {
        this.isRunning = !1;
    }
    fromTo(t, e, { lerp: i = .1, duration: s = 1, easing: o = (t)=>t, onStart: n, onUpdate: l }) {
        this.from = this.value = t, this.to = e, this.lerp = i, this.duration = s, this.easing = o, this.currentTime = 0, this.isRunning = !0, n?.(), this.onUpdate = l;
    }
}
class $5169d9c2c7b13f49$var$Dimensions {
    constructor({ wrapper: t, content: e, autoResize: i = !0 } = {}){
        if (this.wrapper = t, this.content = e, i) {
            const t = function(t, e) {
                let i;
                return function() {
                    let s = arguments, o = this;
                    clearTimeout(i), i = setTimeout(function() {
                        t.apply(o, s);
                    }, e);
                };
            }(this.resize, 250);
            this.wrapper !== window && (this.wrapperResizeObserver = new ResizeObserver(t), this.wrapperResizeObserver.observe(this.wrapper)), this.contentResizeObserver = new ResizeObserver(t), this.contentResizeObserver.observe(this.content);
        }
        this.resize();
    }
    destroy() {
        this.wrapperResizeObserver?.disconnect(), this.contentResizeObserver?.disconnect();
    }
    resize = ()=>{
        this.onWrapperResize(), this.onContentResize();
    };
    onWrapperResize = ()=>{
        this.wrapper === window ? (this.width = window.innerWidth, this.height = window.innerHeight) : (this.width = this.wrapper.clientWidth, this.height = this.wrapper.clientHeight);
    };
    onContentResize = ()=>{
        this.scrollHeight = this.content.scrollHeight, this.scrollWidth = this.content.scrollWidth;
    };
    get limit() {
        return {
            x: this.scrollWidth - this.width,
            y: this.scrollHeight - this.height
        };
    }
}
class $5169d9c2c7b13f49$var$Emitter {
    constructor(){
        this.events = {};
    }
    emit(t, ...e) {
        let i = this.events[t] || [];
        for(let t = 0, s = i.length; t < s; t++)i[t](...e);
    }
    on(t, e) {
        return this.events[t]?.push(e) || (this.events[t] = [
            e
        ]), ()=>{
            this.events[t] = this.events[t]?.filter((t)=>e !== t);
        };
    }
    off(t, e) {
        this.events[t] = this.events[t]?.filter((t)=>e !== t);
    }
    destroy() {
        this.events = {};
    }
}
class $5169d9c2c7b13f49$var$VirtualScroll {
    constructor(t, { wheelMultiplier: e = 1, touchMultiplier: i = 2, normalizeWheel: s = !1 }){
        this.element = t, this.wheelMultiplier = e, this.touchMultiplier = i, this.normalizeWheel = s, this.touchStart = {
            x: null,
            y: null
        }, this.emitter = new $5169d9c2c7b13f49$var$Emitter, this.element.addEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.element.addEventListener("touchstart", this.onTouchStart, {
            passive: !1
        }), this.element.addEventListener("touchmove", this.onTouchMove, {
            passive: !1
        }), this.element.addEventListener("touchend", this.onTouchEnd, {
            passive: !1
        });
    }
    on(t, e) {
        return this.emitter.on(t, e);
    }
    destroy() {
        this.emitter.destroy(), this.element.removeEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.element.removeEventListener("touchstart", this.onTouchStart, {
            passive: !1
        }), this.element.removeEventListener("touchmove", this.onTouchMove, {
            passive: !1
        }), this.element.removeEventListener("touchend", this.onTouchEnd, {
            passive: !1
        });
    }
    onTouchStart = (t)=>{
        const { clientX: e, clientY: i } = t.targetTouches ? t.targetTouches[0] : t;
        this.touchStart.x = e, this.touchStart.y = i, this.lastDelta = {
            x: 0,
            y: 0
        }, this.emitter.emit("scroll", {
            deltaX: 0,
            deltaY: 0,
            event: t
        });
    };
    onTouchMove = (t)=>{
        const { clientX: e, clientY: i } = t.targetTouches ? t.targetTouches[0] : t, s = -(e - this.touchStart.x) * this.touchMultiplier, o = -(i - this.touchStart.y) * this.touchMultiplier;
        this.touchStart.x = e, this.touchStart.y = i, this.lastDelta = {
            x: s,
            y: o
        }, this.emitter.emit("scroll", {
            deltaX: s,
            deltaY: o,
            event: t
        });
    };
    onTouchEnd = (t)=>{
        this.emitter.emit("scroll", {
            deltaX: this.lastDelta.x,
            deltaY: this.lastDelta.y,
            event: t
        });
    };
    onWheel = (e)=>{
        let { deltaX: i, deltaY: s } = e;
        this.normalizeWheel && (i = $5169d9c2c7b13f49$var$t(-100, i, 100), s = $5169d9c2c7b13f49$var$t(-100, s, 100)), i *= this.wheelMultiplier, s *= this.wheelMultiplier, this.emitter.emit("scroll", {
            deltaX: i,
            deltaY: s,
            event: e
        });
    };
}
class $5169d9c2c7b13f49$export$2e2bcd8739ae039 {
    constructor({ wrapper: t = window, content: e = document.documentElement, wheelEventsTarget: i = t, eventsTarget: s = i, smoothWheel: o = !0, syncTouch: n = !1, syncTouchLerp: l = .075, touchInertiaMultiplier: r = 35, duration: h, easing: a = (t)=>Math.min(1, 1.001 - Math.pow(2, -10 * t)), lerp: c = !h && .1, infinite: u = !1, orientation: p = "vertical", gestureOrientation: d = "vertical", touchMultiplier: m = 1, wheelMultiplier: g = 1, normalizeWheel: v = !1, autoResize: S = !0 } = {}){
        this.__isSmooth = !1, this.__isScrolling = !1, this.__isStopped = !1, this.__isLocked = !1, this.onVirtualScroll = ({ deltaX: t, deltaY: e, event: i })=>{
            if (i.ctrlKey) return;
            const s = i.type.includes("touch"), o = i.type.includes("wheel");
            if (this.options.syncTouch && s && "touchstart" === i.type) return void this.reset();
            const n = 0 === t && 0 === e, l = "vertical" === this.options.gestureOrientation && 0 === e || "horizontal" === this.options.gestureOrientation && 0 === t;
            if (n || l) return;
            let r = i.composedPath();
            if (r = r.slice(0, r.indexOf(this.rootElement)), r.find((t)=>{
                var e, i, n, l;
                return (null === (e = t.hasAttribute) || void 0 === e ? void 0 : e.call(t, "data-lenis-prevent")) || s && (null === (i = t.hasAttribute) || void 0 === i ? void 0 : i.call(t, "data-lenis-prevent-touch")) || o && (null === (n = t.hasAttribute) || void 0 === n ? void 0 : n.call(t, "data-lenis-prevent-wheel")) || (null === (l = t.classList) || void 0 === l ? void 0 : l.contains("lenis"));
            })) return;
            if (this.isStopped || this.isLocked) return void i.preventDefault();
            if (this.isSmooth = this.options.syncTouch && s || this.options.smoothWheel && o, !this.isSmooth) return this.isScrolling = !1, void this.animate.stop();
            i.preventDefault();
            let h = e;
            "both" === this.options.gestureOrientation ? h = Math.abs(e) > Math.abs(t) ? e : t : "horizontal" === this.options.gestureOrientation && (h = t);
            const a = s && this.options.syncTouch, c = s && "touchend" === i.type && Math.abs(h) > 5;
            c && (h = this.velocity * this.options.touchInertiaMultiplier), this.scrollTo(this.targetScroll + h, Object.assign({
                programmatic: !1
            }, a ? {
                lerp: c ? this.options.syncTouchLerp : 1
            } : {
                lerp: this.options.lerp,
                duration: this.options.duration,
                easing: this.options.easing
            }));
        }, this.onNativeScroll = ()=>{
            if (!this.__preventNextScrollEvent && !this.isScrolling) {
                const t = this.animatedScroll;
                this.animatedScroll = this.targetScroll = this.actualScroll, this.velocity = 0, this.direction = Math.sign(this.animatedScroll - t), this.emit();
            }
        }, window.lenisVersion = "1.0.37", t !== document.documentElement && t !== document.body || (t = window), this.options = {
            wrapper: t,
            content: e,
            wheelEventsTarget: i,
            eventsTarget: s,
            smoothWheel: o,
            syncTouch: n,
            syncTouchLerp: l,
            touchInertiaMultiplier: r,
            duration: h,
            easing: a,
            lerp: c,
            infinite: u,
            gestureOrientation: d,
            orientation: p,
            touchMultiplier: m,
            wheelMultiplier: g,
            normalizeWheel: v,
            autoResize: S
        }, this.animate = new $5169d9c2c7b13f49$var$Animate, this.emitter = new $5169d9c2c7b13f49$var$Emitter, this.dimensions = new $5169d9c2c7b13f49$var$Dimensions({
            wrapper: t,
            content: e,
            autoResize: S
        }), this.toggleClassName("lenis", !0), this.velocity = 0, this.isLocked = !1, this.isStopped = !1, this.isSmooth = n || o, this.isScrolling = !1, this.targetScroll = this.animatedScroll = this.actualScroll, this.options.wrapper.addEventListener("scroll", this.onNativeScroll, {
            passive: !1
        }), this.virtualScroll = new $5169d9c2c7b13f49$var$VirtualScroll(s, {
            touchMultiplier: m,
            wheelMultiplier: g,
            normalizeWheel: v
        }), this.virtualScroll.on("scroll", this.onVirtualScroll);
    }
    destroy() {
        this.emitter.destroy(), this.options.wrapper.removeEventListener("scroll", this.onNativeScroll, {
            passive: !1
        }), this.virtualScroll.destroy(), this.dimensions.destroy(), this.toggleClassName("lenis", !1), this.toggleClassName("lenis-smooth", !1), this.toggleClassName("lenis-scrolling", !1), this.toggleClassName("lenis-stopped", !1), this.toggleClassName("lenis-locked", !1);
    }
    on(t, e) {
        return this.emitter.on(t, e);
    }
    off(t, e) {
        return this.emitter.off(t, e);
    }
    setScroll(t) {
        this.isHorizontal ? this.rootElement.scrollLeft = t : this.rootElement.scrollTop = t;
    }
    resize() {
        this.dimensions.resize();
    }
    emit() {
        this.emitter.emit("scroll", this);
    }
    reset() {
        this.isLocked = !1, this.isScrolling = !1, this.animatedScroll = this.targetScroll = this.actualScroll, this.velocity = 0, this.animate.stop();
    }
    start() {
        this.isStopped = !1, this.reset();
    }
    stop() {
        this.isStopped = !0, this.animate.stop(), this.reset();
    }
    raf(t) {
        const e = t - (this.time || t);
        this.time = t, this.animate.advance(.001 * e);
    }
    scrollTo(e, { offset: i = 0, immediate: s = !1, lock: o = !1, duration: n = this.options.duration, easing: l = this.options.easing, lerp: r = !n && this.options.lerp, onComplete: h, force: a = !1, programmatic: c = !0 } = {}) {
        if (!this.isStopped && !this.isLocked || a) {
            if ([
                "top",
                "left",
                "start"
            ].includes(e)) e = 0;
            else if ([
                "bottom",
                "right",
                "end"
            ].includes(e)) e = this.limit;
            else {
                let t;
                if ("string" == typeof e ? t = document.querySelector(e) : (null == e ? void 0 : e.nodeType) && (t = e), t) {
                    if (this.options.wrapper !== window) {
                        const t = this.options.wrapper.getBoundingClientRect();
                        i -= this.isHorizontal ? t.left : t.top;
                    }
                    const s = t.getBoundingClientRect();
                    e = (this.isHorizontal ? s.left : s.top) + this.animatedScroll;
                }
            }
            if ("number" == typeof e) {
                if (e += i, e = Math.round(e), this.options.infinite ? c && (this.targetScroll = this.animatedScroll = this.scroll) : e = $5169d9c2c7b13f49$var$t(0, e, this.limit), s) return this.animatedScroll = this.targetScroll = e, this.setScroll(this.scroll), this.reset(), void (null == h || h(this));
                if (!c) {
                    if (e === this.targetScroll) return;
                    this.targetScroll = e;
                }
                this.animate.fromTo(this.animatedScroll, e, {
                    duration: n,
                    easing: l,
                    lerp: r,
                    onStart: ()=>{
                        o && (this.isLocked = !0), this.isScrolling = !0;
                    },
                    onUpdate: (t, e)=>{
                        this.isScrolling = !0, this.velocity = t - this.animatedScroll, this.direction = Math.sign(this.velocity), this.animatedScroll = t, this.setScroll(this.scroll), c && (this.targetScroll = t), e || this.emit(), e && (this.reset(), this.emit(), null == h || h(this), this.__preventNextScrollEvent = !0, requestAnimationFrame(()=>{
                            delete this.__preventNextScrollEvent;
                        }));
                    }
                });
            }
        }
    }
    get rootElement() {
        return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
    }
    get limit() {
        return this.dimensions.limit[this.isHorizontal ? "x" : "y"];
    }
    get isHorizontal() {
        return "horizontal" === this.options.orientation;
    }
    get actualScroll() {
        return this.isHorizontal ? this.rootElement.scrollLeft : this.rootElement.scrollTop;
    }
    get scroll() {
        var t, e;
        return this.options.infinite ? (t = this.animatedScroll, e = this.limit, (t % e + e) % e) : this.animatedScroll;
    }
    get progress() {
        return 0 === this.limit ? 1 : this.scroll / this.limit;
    }
    get isSmooth() {
        return this.__isSmooth;
    }
    set isSmooth(t) {
        this.__isSmooth !== t && (this.__isSmooth = t, this.toggleClassName("lenis-smooth", t));
    }
    get isScrolling() {
        return this.__isScrolling;
    }
    set isScrolling(t) {
        this.__isScrolling !== t && (this.__isScrolling = t, this.toggleClassName("lenis-scrolling", t));
    }
    get isStopped() {
        return this.__isStopped;
    }
    set isStopped(t) {
        this.__isStopped !== t && (this.__isStopped = t, this.toggleClassName("lenis-stopped", t));
    }
    get isLocked() {
        return this.__isLocked;
    }
    set isLocked(t) {
        this.__isLocked !== t && (this.__isLocked = t, this.toggleClassName("lenis-locked", t));
    }
    get className() {
        let t = "lenis";
        return this.isStopped && (t += " lenis-stopped"), this.isLocked && (t += " lenis-locked"), this.isScrolling && (t += " lenis-scrolling"), this.isSmooth && (t += " lenis-smooth"), t;
    }
    toggleClassName(t, e) {
        this.rootElement.classList.toggle(t, e), this.emitter.emit("className change", this);
    }
}

});


var $gxIVK = parcelRequire("gxIVK");
const $8f6a480bb40b134f$export$e85ca3ba4d5e1a9e = new (0, $gxIVK.default)({
    duration: 1.2,
    easing: (t)=>Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true
});
function $8f6a480bb40b134f$var$raf(time) {
    $8f6a480bb40b134f$export$e85ca3ba4d5e1a9e.raf(time);
    requestAnimationFrame($8f6a480bb40b134f$var$raf);
}
$("#menu a").click((e)=>{
    let index = $("#menu a").index(e.currentTarget);
    let scrollTo = index + 1;
    if (index > 1) scrollTo += 1;
    $8f6a480bb40b134f$export$e85ca3ba4d5e1a9e.scrollTo(`#page${scrollTo}`);
});
const $8f6a480bb40b134f$var$changeMainContainerWidth = ()=>{
    if (window.innerWidth > 768) {
        let width = 100 - 20 * window.scrollY / window.innerHeight;
        if (width < 85) width = 85;
        $("#right-container").css("width", `${width}vw`);
        $("#left-container").css("width", `${100 - width}vw`);
    }
    const percentage = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
    $("#pgogression-bar-active").css("width", `${percentage * 100}%`);
    $("#pgogression-bar-unactive").css("width", `${100 - percentage * 100}%`);
};
const $8f6a480bb40b134f$var$loader = ()=>{
    $("#loader p").each(function(index) {
        const timeout1 = setTimeout(()=>{
            $(this).css("transform", "translateY(0%)");
        }, 100 * index);
        const timeout2 = setTimeout(()=>{
            $(this).css("transform", "translateY(-100%)");
        }, 1000 + 100 * index);
        window._config.timouts.push(timeout1, timeout2);
    });
    $("#page1 h2").each(function(index) {
        $(this).css("transform", "translateY(100%)");
    });
    $("#menu a p").each(function(index) {
        $(this).css("transform", "translateY(100%)");
    });
    const timeout3 = setTimeout(()=>{
        $("#loader").css("transform", "translateY(-100%)");
        setTimeout(()=>{
            $("#loader").css("display", "none");
        }, 700);
        $("#page1 h2").each(function(index) {
            const timeout4 = setTimeout(()=>{
                $(this).css("transform", "translateY(0%)");
            }, 100 * index);
            window._config.timouts.push(timeout4);
        });
        const timeout5 = setTimeout(()=>{
            $("#menu a p").each(function(index) {
                $(this).css("transform", "translateY(0%)");
            });
        }, 100 * $("#page1 h1").length);
        window._config.timouts.push(timeout5);
        requestAnimationFrame($8f6a480bb40b134f$var$raf);
    }, 1100 + $("#loader p").length * 100);
    window._config.timouts.push(timeout3);
};
window.addEventListener("scroll", function(e) {
    if (!window._config.isLoading) this.requestAnimationFrame($8f6a480bb40b134f$var$changeMainContainerWidth);
});
document.addEventListener("DOMContentLoaded", function() {});
window.addEventListener("DOMContentLoaded", function() {
    window._config = {
        timouts: []
    };
    $8f6a480bb40b134f$var$loader();
    window.onCaptchaSuccess = function() {
        document.getElementById("captcha").style.display = "none";
        document.getElementById("submitButton").style.display = "block";
    };
});
window.addEventListener("load", function() {
    window.scrollTo(0, 0);
});
window.addEventListener("pagehide", function(e) {
    window._config.timouts.forEach((element)=>{
        clearTimeout(element);
    });
    window.scrollTo(0, 0);
});


//# sourceMappingURL=index.9b4d2532.js.map
